import Image from "next/image";
import Link from "next/link";
export default function LogoLink() {
  return (
    <div className="text-center sm:mb-0">
      <Link href="/">
        <div className="flex items-center gap-4">
          <Image
            width={128}
            height={48}
            className="rounded-full"
            src="/assets/images/eyamLogo.png"
            alt="Profile Image"
          />
        </div>
      </Link>
    </div>
  );
}
